import React from 'react'
import Style from '../productAttribute.module.css'

const RequiredFlag = ({ isRequired }) => (
    <span
        className={isRequired ? Style.requiredYes : Style.requiredNo}
        title={isRequired ? 'Required' : 'Not required'}
    >
        <i className={isRequired ? 'uil-check' : 'uil-minus'} aria-hidden="true" />
        <span className={Style.srOnly}>{isRequired ? 'Required' : 'Not required'}</span>
    </span>
)

export default RequiredFlag
